import React from "react";
import { Link } from "react-router-dom";
import { ImageUrl } from "../../../../../../Helpers/request";
import InstaIframe from "../../../../InstaIframe";
import { LazyLoadImage } from "react-lazy-load-image-component";
export const InstagramFeed = () => {
  return (
    <>
      <section className="instafeed my-5 pt-4">
        <div className="container">
          <div className="title-box text-center mb-2">
            <h2>GET A TOUR OF OUR SOCIAL MEDIA</h2>
            <LazyLoadImage
              src={`${ImageUrl}theme/newyork/Slider/line-black.png`}
              alt=""
            />
          </div>

          <p className="text-center">
            Follow{" "}
            <a
              rel="noreferrer"
              target="_blank"
              href="https://www.instagram.com/belgium_webnet/"
              className="text-dark"
            >
              @belgium_webnet
            </a>{" "}
            on Instagram to get inspired
          </p>
        </div>
        <InstaIframe />
      </section>
    </>
  );
};
